import React from "react";
import ColorField from "../fields/ColorField";
import { numberOrZero } from "../shared";
import "../DesignerPropertiesPanel.css";

const CommonStyleSection = ({ selectedObject, updateObjectStyleField }) => {
  const styleJson = selectedObject.style_json || {};

  return (
    <div className="dp-section">
      <h4 className="dp-section-title">Style</h4>

      <ColorField
        label="Text Color"
        value={styleJson.color || ""}
        fallback="#111827"
        onTextChange={(value) =>
          updateObjectStyleField(selectedObject.id, "color", value)
        }
        onPickerChange={(value) =>
          updateObjectStyleField(selectedObject.id, "color", value)
        }
      />

      <ColorField
        label="Background Color"
        value={styleJson.backgroundColor || ""}
        fallback="#ffffff"
        onTextChange={(value) =>
          updateObjectStyleField(selectedObject.id, "backgroundColor", value)
        }
        onPickerChange={(value) =>
          updateObjectStyleField(selectedObject.id, "backgroundColor", value)
        }
      />

      <div className="dp-field">
        <label className="dp-label">Font Size</label>
        <input
          type="number"
          value={styleJson.fontSize || ""}
          onChange={(e) =>
            updateObjectStyleField(
              selectedObject.id,
              "fontSize",
              e.target.value === "" ? "" : numberOrZero(e.target.value)
            )
          }
          className="dp-input"
        />
      </div>

      <div className="dp-field">
        <label className="dp-label">Border Radius</label>
        <input
          type="number"
          value={styleJson.borderRadius || ""}
          onChange={(e) =>
            updateObjectStyleField(
              selectedObject.id,
              "borderRadius",
              e.target.value === "" ? "" : numberOrZero(e.target.value)
            )
          }
          className="dp-input"
        />
      </div>
    </div>
  );
};

export default CommonStyleSection;